import * as _ from 'lodash';
import { Injectable  } from "@angular/core";

// This is a modified version from https://github.com/cornflourblue/angular2-pagination-example
@Injectable()
export class PaginationService {
    getPaginationObject(totalRecords: number, currentPage: number = 1, entriesPerPage: number = 25) {
        // Find out total number of pages
        const totalPages = Math.ceil(totalRecords / entriesPerPage);

        let startPage: number, endPage: number;
        // Displaying only 5 pages at a time
        if (totalPages <= 5) {
            startPage = 1;
            endPage = totalPages;
        } else {
            if (currentPage <= 3) {
                startPage = 1;
                endPage = 5;
            } else if (currentPage + 1 >= totalPages) {
                startPage = totalPages - 4;
                endPage = totalPages;
            } else {
                startPage = currentPage - 2;
                endPage = currentPage + 2;
            }
        }

        // calculate start and end item indexes
        const startIndex = (currentPage - 1) * entriesPerPage;
        const endIndex = Math.min(startIndex + entriesPerPage - 1, totalRecords - 1);

        // create an array of pages to ng-repeat in the pager control
        const pages = _.range(startPage, endPage + 1);

        // return object with all pager properties required by the view
        return {
            totalRecords: totalRecords,
            entriesPerPage: entriesPerPage,
            currentPage: currentPage,
            totalPages: totalPages,
            startPage: startPage,
            endPage: endPage,
            startIndex: startIndex,
            endIndex: endIndex,
            pages: pages
        };
    }
}
